// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */
import uuid from 'uuid';
import {fetchContext} from 'cchome-shared/utils';
import getConfigApps from '../config';

const constants = {
	source: 'CCHome',
	apiKey: 'cchome-web-service',
	xApiKey: 'cchome-web-service',
	project: 'cchome-web-service',
	clientID: 'CCHomeWeb1'
};

/**
 * A class for initializing the Ingest module
 */
class AnalyticsUtil {
	contextGuid: string;
	contextParams: string;
	contextInit: boolean;
	contextInitialized: boolean;

	setContext() {
		if (!this.contextInitialized) {
			const domain = getConfigApps('COOKIE_DOMAIN');
			const secure = getConfigApps('COOKIE_SECURE');
			// $FlowFixMe - bug https://github.com/facebook/flow/issues/6580
			[this.contextGuid, this.contextParams, this.contextInit] = fetchContext(uuid, domain, secure);
			this.contextInitialized = true;
		}
	}

	initAnalytics() {
		const initObj: Object = {};
		initObj.xApiKey = constants.xApiKey;
		initObj.apiKey = constants.apiKey;
		initObj.clientId = constants.clientID;
		initObj.project = constants.project;
		initObj.source = constants.source;
		initObj.environment = 'stage'; // config.env;
		initObj.useLocalReferrer = true;
		initObj.referrerStorageName = 'creative-cloud-referrer';
		return initObj;
	}

}

export default new AnalyticsUtil();


